export enum GroupingActionOnPropertyEnum {
  TAKE_FIRST = 0,
  FIXED_VALUE = 1,
  AGGREGATE = 2,
  CONCATENATE = 3,
  LEAVE_EMPTY = 4,
  CONCATENATE_DISTINCT = 5,
  GROUP_NAME = 6,
  ALL = 7
}